
import { useMemo } from 'react';
import { useMapData, useMapFilters, useRegionData, useMapVisibility } from './hooks';

interface UseDeviceMapProps {
  deviceType?: 'energy' | 'gas' | 'water';
}

export const useDeviceMap = ({ deviceType = 'energy' }: UseDeviceMapProps) => {
  // Define region arrays for each utility type
  const regionNames = ["North", "South", "East", "West", "Central"];
  
  // Use custom hooks to separate concerns
  const { allDevices, consumers, defaultCenter, zoom } = useMapData(deviceType);
  const { showDevices, showConsumers, setShowDevices, setShowConsumers } = useMapVisibility();
  const { filterCategories, activeFilters, filteredDevices, handleFilterChange, handleClearFilters } = useMapFilters(deviceType, allDevices);
  const { regions, deviceCounts } = useRegionData(regionNames);
  
  return {
    defaultCenter,
    zoom,
    showDevices,
    showConsumers,
    setShowDevices,
    setShowConsumers,
    filteredDevices,
    consumers,
    filterCategories,
    activeFilters,
    handleFilterChange,
    handleClearFilters,
    regions,
    deviceCounts
  };
};
